import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../../utility/Constant";

function CertificateCard({ project, user, handleSingleDelete }) {
  const { aboutUsCertificateList, aboutUsCertificateListAdd } = RoutePath;
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };
  return (
    <>
      {visibility ? (
        <div className="group border h-[24rem] md:min-h-[35rem] flex flex-col justify-between bg-base-100 shadow-lg rounded-lg overflow-hidden">
          {project ? (
            <>
              <div>
                <figure>
                  <img
                    src={project?.image?.url}
                    alt={project.title + " " + "Image"}
                    className="h-[150px] md:h-[300px] object-cover w-full"
                  />
                </figure>

                <div className="p-2 md:p-3 flex flex-col gap-4">
                  <span className="text-xs md:text-base font-medium text-gray-900">
                    <span className="font-semibold">Certification Date: </span>
                    {project.date}
                  </span>
                  <h2 className="text-sm md:text-lg font-semibold break-words">
                    {project.title}
                  </h2>
                </div>
              </div>
              <div className="p-3 border-t flex justify-between gap-2">
                <Link
                  to={`/${aboutUsCertificateList}/${project._id}`}
                  className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white py-2 w-24 transition duration-150 border text-center rounded-lg text-xs md:text-base"
                >
                  Edit
                </Link>
                {user === "admin" && (
                  <button
                    id={project._id}
                    onClick={handleDelete}
                    className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white py-2 w-24 transition duration-150 border text-center rounded-lg text-xs md:text-base"
                  >
                    Delete
                  </button>
                )}
              </div>
            </>
          ) : (
            <Link
              to={`/${aboutUsCertificateListAdd}`}
              className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
            >
              <p className="text-8xl group-hover:text-primary">
                <AiFillFileAdd />
              </p>
            </Link>
          )}
        </div>
      ) : null}
    </>
  );
}

export default CertificateCard;
